export default __webpack_public_path__ + "static/foot-container-bg-dc5158c372df91d738b74ebe6955279c.jpg";